import React, { useEffect, useState, useRef } from 'react'
import { useRequest } from 'ahooks'

import CopyRight from '@kiss/components/CopyRight'
import ToKissFooter from '@kiss/components/ToKissFooter'

import { getBookDataByID } from '@kiss/services/shareBookPage'

// import bindElementToClipBoard from '@/utils/clip'
import { getLocationVars } from '@/utils/utils'

import './App.scss'

import headerLogo from '@kiss/assets/logos/icon_kiss.png'

import { isArray } from 'lodash'
import PopularBook from './components/popularBook'
import BookInfo from './components/bookInfo'
import NextPng from '@kiss/pages/shareComicPage/assets/next.png'
import RightPng from '@kiss/pages/shareComicPage/assets/right.png'
import YhPng from '@kiss/pages/shareComicPage/assets/yh.png'
import WatermarkPng from '@kiss/pages/shareComicPage/assets/watermark.png'

import { getAdjustDeeplink } from '@kiss/utils/url'
import { getUA, converUrlParamsObj, deepLink } from '@kiss/utils/urils'

import { clickGet } from '@/projects/kiss/utils/reportInfo/reportedMethods'
import { IClickGet } from '@/projects/kiss/utils/reportInfo/types'

import { watermark } from '@kiss/utils/urils'
export interface IBookData {
  _id: string
  author_name: string[]
  book_desc: string
  book_id: string
  book_pic: string
  book_title: string
  read_count: number
  tag: Array<string>
  theme: Array<string>
  update_status: number
  app_icon?: string
  // 漫画首章内容图片数组
  first_chapter?: Array<string>
  recommend_books?: Array<IBookData>
  first_chapter_id?: string | number
}

const App: React.FC = () => {
  const { bookId }: { bookId?: string } = getLocationVars()
  const urlQueryParams = getLocationVars()

  /** 上报参数的公共参数 */
  const clickParam = useRef<IClickGet>({
    eid: 12,
    parm5: 'h5_comic_share_click',
    parm9: location.href
  })

  const reportData = (action: 1 | 2) => {
    // 上报
    clickGet({
      ...clickParam.current,
      parm1: 5
    })
  }

  const { data, error } = useRequest(
    () => getBookDataByID({ id: bookId, business_id: 3 }),
    {}
  )

  // 跳deeplink阅读页
  const handleDeeplink = (bookId: string) => {
    let href = ''
    href = getAdjustDeeplink({
      customParams: {
        parm1: bookId
      },
      type: 1001,
      isForTest: true,
      pushType: 1, // 分享H5页面的pushType ==1 默认跳到阅读页
      contentType: 3 // 1-小说  2-audio   3-comic
    })
    window.location.href = href
  }

  // 点击more跳转大厅
  const deeplinkToHall = (props: {
    bookId: string
    pushType: 0 | 1 | 2 | 3
  }) => {
    const { bookId, pushType = 0 } = props
    const contentType = 3
    const href = deepLink(bookId, pushType, contentType)
    window.location.href = href
  }

  const bookData: IBookData = data?.data || {}

  const formatDesc = (desc: string) => {
    //  let  newdesc = ''
    //  newdesc = desc.replace(/?!(.{3})/ig,//n/)

    return desc
  }

  const paragraphList = isArray(bookData?.first_chapter)
    ? bookData?.first_chapter
    : []

  useEffect(() => {
    // 上报页面加载完成
    clickGet({
      ...clickParam.current,
      parm1: 1
    })
  }, [])

  useEffect(() => {
    document.title = bookData?.book_title || ''
  }, [bookData?.book_title])

  if (!bookId) return <>Missing required parameters</>

  if (error) return <>An error has occurred, please try again</>

  if (data?.code !== 0) return <>{JSON.stringify(data?.msg)}</>

  return (
    <div className='page-ctr'>
      <header>
        <img src={headerLogo} alt='' />
      </header>

      <BookInfo bookData={bookData} />

      <div className='summary-desc'>
        <div className='summary-top-yh'>
          <img src={YhPng} alt='' />
        </div>
        <div className='summary-book-desc'>
          {formatDesc(bookData?.book_desc) || ''}
        </div>

        <div className='summary-bottom-yh'>
          <img src={YhPng} alt='' />
        </div>
      </div>

      <div className='summary-ctr'>
        <div className='summary-title'>Chapter1</div>
        <div className='summary-content'>
          {paragraphList?.map((item: string) => {
            const img = new Image()
            img.src = item

            //  watermark({src:item, className:'.summary-content'})

            return (
              <div className='content-img'>
                <img src={item} alt='' />
                <div className='watermark'>
                  <img src={WatermarkPng} alt='' />
                </div>
              </div>
            )
          })}
        </div>

        <div
          className='summary-next'
          onClick={() => {
            handleDeeplink(bookId)
            // 上报点击展开button
            clickGet({
              ...clickParam.current,
              parm1: 2,
              parm7: bookId,
              parm6: String(bookData.first_chapter_id)
            })
          }}
        >
          <img src={NextPng} alt='' />
        </div>
        <div
          className='summary-toReader'
          onClick={() => {
            handleDeeplink(bookId)
            // 上报点击展开button
            clickGet({
              ...clickParam.current,
              parm1: 2,
              parm7: bookId,
              // to do  章节id 待改
              parm6: String(bookData.first_chapter_id)
            })
          }}
        >
          Click to read the whole comic
        </div>

        <div className='summary-title'>Popular Reading</div>
        <div className='summary-popular'>
          {bookData &&
            bookData?.recommend_books?.map((i: IBookData) => {
              return (
                <PopularBook
                  data={i}
                  handleDeeplink={() => {
                    handleDeeplink(i.book_id)
                    // 上报点击相似书籍封面
                    clickGet({
                      ...clickParam.current,
                      parm1: 3,
                      parm7: bookId
                    })
                  }}
                />
              )
            })}
          <div
            className='summary-popular-more'
            onClick={() => {
              deeplinkToHall({ bookId: bookId, pushType: 0 })
              // 上报点击More
              clickGet({
                ...clickParam.current,
                parm1: 4
              })
            }}
          >
            <span>More</span>
            <img src={RightPng} alt='' />
          </div>
        </div>
      </div>
      <CopyRight />
      <ToKissFooter
        kissLinkData={{
          ...urlQueryParams,
          type: 1001,
          isForTest: true,
          pushType: 1,
          contentType: 3
        }}
        reportData={reportData}
        appIcon={bookData?.app_icon}
        customParamsDic={{ parm1: 'bookId' }}
      ></ToKissFooter>
    </div>
  )
}

export default App
